import React, { Children } from "react";
import { Flex, Card, Input, Divider, Empty } from "antd";
import { SwapOutlined, EditOutlined, EllipsisOutlined, ShoppingOutlined, BarcodeOutlined, LinkOutlined } from "@ant-design/icons";
import GoodsCard from './card';


export default ({list = [], ...others}) => {

    return (
        <Flex justify="start" wrap gap={15} align="center">
            {
                list.map((item, index) => {
                    return (
                        <GoodsCard {...others} content={item} key={index} />
                    )
                })
            }
            {list.length === 0 && <Empty style={{width: '100%'}} />}
        </Flex>
    );
};
